<template>
  <el-col :span="24">
    <el-col :span="24" >
      <el-col :span="18" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
        <ComponentDatePicker ref="ComponentDatePicker"></ComponentDatePicker>
      </el-col>
      <el-col :span="6" style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
        <el-button type="danger" @click="ostentation_time">按时间查询</el-button>
        <el-button type="danger" @click="daochu">导出</el-button>
        <el-button type="primary" @click="add_information()">添加</el-button>
      </el-col>
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    "
    border
     style="width: 100%">
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <!-- <el-table-column label="序号" prop="id"> </el-table-column> -->
      <el-table-column label="日期" prop="time_start">
        <template slot-scope="scope">
          {{ret_YearMonthDate(scope.row.time_start)}}
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="time_end">
        <template slot-scope="scope">
          {{ret_YearMonthDateHoursMin(scope.row.time_start)}} ~ {{ret_YearMonthDateHoursMin(scope.row.time_end)}}
        </template>
      </el-table-column>
      <el-table-column label="商品"  align="center" prop="goods_name"> </el-table-column>
      <el-table-column label="手机号" prop="phone" ></el-table-column>
      <el-table-column label="实收金额" prop="net_receipts" ></el-table-column>
      <el-table-column label="支付订单号" prop="payment_serial_number" ></el-table-column>
      <el-table-column align="left" label="信息操作" width="250">
        <template slot-scope="scope">
          <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="warning" @click="modify_information(scope.row)" v-show="scope.row.store_id==0">修改信息</el-button>
          <el-popconfirm
            title="确认删除此条排场？"
            @confirm="delete_information(scope.row)"
          >
            <el-button slot="reference" type="danger" v-show="scope.row.store_id==0">删除信息</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible" width="30%">
      <el-form  :model="form"  :label-width="formLabelWidth">
        <el-form-item label="时间:">
          <el-date-picker
                v-model="value1"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                 value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                >
              </el-date-picker>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="商品:">
            <el-select style="width: 100%;" v-model="select_value" placeholder="请选择">
              <el-option v-for="item in select_options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="实收金额:">
          <el-input v-model="form.net_receipts" placeholder="请输入实收金额"></el-input>
        </el-form-item>
        <el-form-item label="支付订单号:">
          <el-input v-model="form.payment_serial_number" placeholder="请输入支付订单号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="startGame">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="dialogFormVisible_modify" width="30%">
      <el-form :model="form" :label-width="formLabelWidth">
        <el-form-item label="时间:">
          <el-date-picker
                v-model="value1"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                 value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                >
              </el-date-picker>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="商品:">
            <el-select style="width: 100%;" v-model="select_value" placeholder="请选择">
              <el-option v-for="item in select_options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="实收金额:">
          <el-input v-model="form.net_receipts" placeholder="请输入实收金额"></el-input>
        </el-form-item>
        <el-form-item label="支付订单号:">
          <el-input v-model="form.payment_serial_number" placeholder="请输入支付订单号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="startGame_modify">确 定</el-button>
      </div>
    </el-dialog>
  </el-col>
</template>

<script>
  import {
    protocol_ZgrShopOstentation_Lobbygames_list,
    protocol_ZgrShopOstentationOrder_Lobbygames_eidt,
    protocol_ZgrShopOstentationOrder_Lobbygames_add,
    protocol_ZgrShopOstentationOrder_Lobbygames_delete
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'

  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
      gUtilityExcel
    } from "@/assets/js/utility/UtilityExcel";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        modify_div:'',
        tableData: [],
        shop_game:[],
        search: '',
        dialogFormVisible: false,
        dialogFormVisible_modify:false,
        btnChangeEnable:false,
        form: {
          phone:"",
          net_receipts:'',
          payment_serial_number:'',
        },
        select_value: "前厅半小时",
        select_options: [{
          value: '前厅半小时',
          label: '前厅半小时'
        }, {
          value: '前厅一小时',
          label: '前厅一小时'
        }, {
          value: '一番赏',
          label: '一番赏'
        }],
        formLabelWidth: '120px',
        value1: [],
      }
    },
    methods: {
      //按时间查询
      ostentation_time(){
        this.init_list(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start())/1000,gUtilityTime.endTime(this.$refs.ComponentDatePicker.get_time_end())/1000)
      },
      //添加信息
      add_information(){
        this.dialogFormVisible = true;
        this.value1 = [new Date(), new Date()];
        this.form.phone ='';
        this.select_value="前厅半小时";
        this.form.net_receipts='';
        this.form.payment_serial_number='';
        this.modify_div='';
      },
      // 删除信息
      delete_information(row){
        let _this=this;
        protocol_ZgrShopOstentationOrder_Lobbygames_delete(row.id).then(res=>{
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
           _this.init_list();
        })
      },
      game_name(id){
        return gGameData.getDataByID(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      // 修改信息
      modify_information(row){
        this.dialogFormVisible_modify = true;
        this.value1 = [new Date(row.time_start*1000), new Date(row.time_end*1000)];
        this.form.phone =row.phone;
        this.select_value=row.goods_name;
        this.modify_div=row;
        this.form.net_receipts=row.net_receipts;
        this.form.payment_serial_number=row.payment_serial_number;

      },
      //修改提交
      startGame_modify(row){
        var _this = this;
        if(this.value1.length==0){
          this.$message({
            message: '时间不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.net_receipts==""){
          this.$message({
            message: '实收金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.payment_serial_number==""){
          this.$message({
            message: '支付订单号不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Lobbygames_eidt(
        this.form.phone,
        (new Date(this.value1[0]).getTime())/1000,
        (new Date(this.value1[1]).getTime())/1000,
        this.select_value,
        this.modify_div.id,
        this.form.net_receipts,
        this.form.payment_serial_number
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '修改成功',
              type: 'success'
            });
            _this.dialogFormVisible_modify=false;
            _this.init_list();
          }
        })
      },
      daochu(){
        let title=`序号,日期,时间,商品,手机号,实收金额,支付订单号\n`;
        let data=[];
        for(let i=0;i<this.tableData.length;i++){
          let obj=Object();
          obj.index=(i+1);
          obj.time_start=this.ret_YearMonthDate(this.tableData[i].time_start);
          obj.time_start1=this.ret_YearMonthDateHoursMin(this.tableData[i].time_start) +"~"+ this.ret_YearMonthDateHoursMin(this.tableData[i].time_end);
          obj.people_count=this.tableData[i].goods_name;
          obj.phone=this.tableData[i].phone;
          obj.net_receipts=this.tableData[i].net_receipts;
          obj.payment_serial_number=this.tableData[i].payment_serial_number;
          data.push(obj)
        }
        gUtilityExcel.download_excel("前厅游戏数据.xls",title,data)
      },
      //提交
      startGame() {
        var _this = this;
        if(this.value1.length==0){
          this.$message({
            message: '时间不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.net_receipts==""){
          this.$message({
            message: '实收不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.payment_serial_number==""){
          this.$message({
            message: '支付订单号不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Lobbygames_add(
        this.form.phone,
        (new Date(this.value1[0]).getTime())/1000,
        (new Date(this.value1[1]).getTime())/1000,
        this.select_value,
        this.form.net_receipts,
        this.form.payment_serial_number
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '添加成功',
              type: 'success'
            });
            _this.dialogFormVisible=false;
            _this.init_list();
          }
        })
      },
      //关闭弹窗
      cannelStartGame() {
        this.dialogFormVisible = false;
        this.dialogFormVisible_modify = false;
      },
      init_list(time_start,time_end){
        let _this=this;
        let date=new Date();
        if(time_start==undefined){
          time_start=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),1);
          time_end=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),2);
        }
        protocol_ZgrShopOstentation_Lobbygames_list(time_start,time_end).then(res=>{
          _this.tableData=res.ret;
        })
      }
    },
    mounted() {
      this.DaySafter_list=gUtilityTime.DaySafter7();
      this.radio1=this.DaySafter_list[0];
      this.shop_game = gGameData.getAllDataShopData();
      this.init_list();
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/LobbyGames.vue